import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AnnouncementService } from './api/announcement.service';
import { AnnouncementAdminService } from './api/announcement-admin.service';
import { AppAdminService } from './api/app-admin.service';
import { BrandingService } from './api/branding.service';
import { ConfigService } from './api/config.service';
import { ContextService } from './api/context.service';
import { EulaService } from './api/eula.service';
import { IconService } from './api/icon.service';
import { MaintenanceService } from './api/maintenance.service';
import { MaintenanceAdminService } from './api/maintenance-admin.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
